module.exports = __webpack_public_path__ + "img/project-6.4a2acef7.jpg";